// GeoZonasPage.js
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polygon, Circle, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import GeoZonasLogic from './GeoZonasLogic'; // lógica de dibujo
import './GeozonasPage.css';


const GeoZonasPage = () => {
  const [zonas, setZonas] = useState([]);

  useEffect(() => {
    const fetchZonas = async () => {
      try {
        const res = await fetch('http://localhost:3000/api/geozonas');
        const data = await res.json();
        if (data.ok) setZonas(data.zonas);
      } catch (error) {
        console.error('Error cargando zonas:', error);
      }
    };

    fetchZonas();
  }, []);

  return (
    <div style={{ display: 'flex', height: '100vh', paddingLeft: '70px' }}>
      <div style={{ width: '300px', overflowY: 'auto', background: '#f8f8f8', padding: '10px', borderRight: '1px solid #ccc' }}>
        <h4>Zonas definidas</h4>
        {zonas.map((zona) => (
          <div key={zona.id} style={{ marginBottom: '10px', padding: '5px', border: '1px solid #ddd', borderRadius: '4px' }}>
            <strong>{zona.nombre}</strong><br />
            Tipo: {zona.tipo}
          </div>
        ))}
      </div>

      <div style={{ flex: 1 }}>
        <MapContainer center={[19.436294, -99.072632]} zoom={17} scrollWheelZoom={true} style={{ height: '100%' }}>
          <TileLayer
            attribution='&copy; OpenStreetMap contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* Mostrar zonas */}
          {zonas.map((zona) => {
            if (zona.tipo === 'poligono' && zona.coordenadas) {
              return (
                <Polygon key={zona.id} positions={zona.coordenadas} pathOptions={{ color: 'blue' }} />
              );
            } else if (zona.tipo === 'circulo') {
              return (
                <Circle
                  key={zona.id}
                  center={[zona.centro_lat, zona.centro_lng]}
                  radius={zona.radio}
                  pathOptions={{ color: 'green' }}
                />
              );
            }
            return null;
          })}

          {/* Lógica de dibujo */}
          <GeoZonasLogic recargarZonas={() => window.location.reload()} />
        </MapContainer>
      </div>
    </div>
  );
};

export default GeoZonasPage;
